






































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import emitter from "@/lib/emitter";
import { getPostAllowedFileTypes } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseDropZone from "@/components/BaseDropZone";
import BaseInputFile from "@/components/BaseInputFile";
import PageTitle from "@/components/PageTitle";
import VaultController from "@/components/VaultController";

export default defineComponent({
  name: "VaultFilesAdapter",
  components: { PageTitle, BaseInputFile, VaultController, BaseDropZone },
  props: {
    maxFiles: { type: Number },
    minFiles: { type: Number },
    allowedTypes: { type: Array as PropType<string[]> },
  },
  setup(props, { emit }) {
    const filteredAllowedTypes = computed(() => getPostAllowedFileTypes(props.allowedTypes));
    const addFiles = (files: File[]) => {
      emit("addFiles", files);
      emit("closeVault");
    };

    const addFromVault = (files: VaultFile[]) => {
      if (props.allowedTypes) {
        const isTypeRestricted = (type: string) => props.allowedTypes && !props.allowedTypes.includes(type);
        if (files.some(file => isTypeRestricted(file.contentType.split("/")[0]))) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Chosen file type is not allowed"), position: "top" });
          return;
        }
      }
      if (props.minFiles && files.length < props.minFiles) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, {
          text: $t("Please select at least {0} files", [props.minFiles]),
          position: "top",
        });
        return;
      }
      emit("addFilesFromVault", files);
      emit("closeVault");
    };

    const showUpload = ref(true);
    const showTitle = ref(true);

    return {
      filteredAllowedTypes,
      addFiles,
      addFromVault,
      showUpload,
      showTitle,
    };
  },
});
